@if(data) {
    <div class="snackbar">
    @if(!data.isComplete) {
        <div>
            <span class="smallSpinner loading">
                    <span class="spinner-wrapper">
                        <span class="spinner"></span>
                    </span>
            </span>
            <span class="message">{{data.message | translate}}</span>

        </div>
        <div>@if(data.progress) {

            <span>{{data.progress  | number : '1.2-2' : locale}}</span><span> %</span>
        }
        </div>
    }
        @if(data.isComplete) {
            <span class="message">{{data.message | translate}}</span>
            <span matSnackBarActions><button mat-raised-button (click)="download()">{{'download_all_files' | translate}}</button></span>
        }
    </div>
}
